import type { ReactNode } from 'react'
import { StyledChoice, StyledChoiceDescription, StyledChoiceIcon, StyledChoiceTitle } from '../styled-components'

interface ChoiceCardProps {
  icon: ReactNode
  title: string
  description: string
  selected: boolean
  onSelect: () => void
}

const ChoiceCard = ({ icon, title, description, selected, onSelect }: ChoiceCardProps) => (
  <StyledChoice type='button' aria-pressed={selected} $selected={selected} onClick={onSelect}>
    <StyledChoiceTitle>
      <StyledChoiceIcon>{icon}</StyledChoiceIcon>
      {title}
    </StyledChoiceTitle>
    <StyledChoiceDescription>{description}</StyledChoiceDescription>
  </StyledChoice>
)

export default ChoiceCard
